import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { LicenceStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-licence-status-container',
  templateUrl: './licence-status-container.component.html',
  styleUrls: ['./licence-status-container.component.scss'],
})
export class LicenceStatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  licencestatuss$: Observable<LicenceStatusDto[]>;
  loading: boolean;
  isLoadingLicenceStatus$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingLicenceStatus$ = this.gatwayFacade.isLoadingGateway(
      'LicenceStatus'
    );
    this.licencestatuss$ = this.gatwayFacade.loadGateway('LicenceStatus');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLicenceStatus(deletedValue: any) {
    this.gatwayFacade.remove('LicenceStatus', deletedValue);
  }

  // this method control both the create and update

  onSubmitLicenceStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.LicenceStatuss;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllLicenceStatus = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllLicenceStatus.push(pullData[i]);
      }
    }

    // check if the addAllLicenceStatus array is not empty, then dispatch the data to the store
    if (addAllLicenceStatus.length > 0) {
      this.gatwayFacade.add('LicenceStatus', addAllLicenceStatus);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('LicenceStatus', allUpdates, ['id']);
    }
  }
}
